import type { ConferenceExhibitionItem } from './types';

const splitConferenceExhibitionTags = (value?: string) =>
  `${value || ''}`
    .split('、')
    .map((item) => item.trim())
    .filter(Boolean);

export const getConferenceExhibitionTags = (
  item: ConferenceExhibitionItem,
  locale: 'zh' | 'en'
) =>
  locale === 'zh'
    ? splitConferenceExhibitionTags(item.tagsCN)
    : splitConferenceExhibitionTags(item.tagsEN);
